import template from "./deployment-list.html";
import controller from "./deployment-list.controller";
import "./deployment-list.scss";

const Component = {
	template,
	controller,
	controllerAs: "controller"
};

export default Component;


// WEBPACK FOOTER //
// ./sources/components/deployments/deployment-list/deployment-list.component.js